import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import React, { useRef, useState } from 'react';
import PrivatePensionForm, {
  PrivatePensionFormRef,
  PrivatePensionFormValues,
} from './PrivatePensionForm';

type CreatePrivatePensionModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: PrivatePensionFormValues) => Promise<void>;
};

const CreatePrivatePensionModal: React.FC<CreatePrivatePensionModalProps> = ({
  isOpen,
  toggle,
  onSubmit,
}) => {
  const { messages } = useTypedIntl();
  const formRef = useRef<PrivatePensionFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: PrivatePensionFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.createPrivatePensionSetting']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <PrivatePensionForm formRef={formRef} onSubmit={handleSubmit} />
    </AppModalContainer>
  );
};

export default CreatePrivatePensionModal;
